import useTranslate from 'modules/local/useTranslate'
import {NullAsDefault} from 'views/Shared'
import useAsyncAction from "../../../modules/asyncCache/useAsyncAction";
import {promo_add_Api, promo_remove_Api} from "../../../apis";
import {notifyOnError} from "../../AppLocals/factory/createErrorEvent";
import {NotificationActionTypes, successNotify} from "../../AppLocals/factory/createNotification";


export const usePromoFunc = ({
                               notifyListeners = {
                                 onCreated: undefined,
                                 onDeleted: undefined,
                               },
                             }) => {
  const t = useTranslate()

  const {
    onCreated = NullAsDefault,
    onDeleted = NullAsDefault,
  } = notifyListeners ?? {}

  const onError = notifyOnError(t)

  const {handleAsyncAction: onAddToRecommendation, ...asyncCreating} = useAsyncAction({
    onError,
    apiInfo: promo_add_Api,
    onSuccess: (result, data) => {
      successNotify(NotificationActionTypes.CREATE, t)
      onCreated(result, data)
    },
  })

  const {handleAsyncAction: onRemoveFromRecommendation, ...asyncDeleting} = useAsyncAction({
    onError,
    apiInfo: promo_remove_Api,
    onSuccess: (result, data) => {
      successNotify(NotificationActionTypes.DELETE, t)
      onDeleted(result, data)
    },
  })


  return {
    onAddToRecommendation,
    onRemoveFromRecommendation,
    asyncCreating,
    asyncDeleting,
  }
}



